import React, { useEffect, useState } from 'react';
import { withStyles, MuiThemeProvider } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import CardIcon from '@components/CardIcon/CardIcon';
import Grid from '@material-ui/core/Grid';
import TextField from '@components/TextFieldOwn/TextFieldOwn';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Check from '@material-ui/icons/Check';
import Close from '@material-ui/icons/Close';
import ButtonFABMenu from '@components/ButtonFABMenu/ButtonFABMenu';
import CircularProgress from '@material-ui/core/CircularProgress';
import swal from '@sweetalert/with-react';
import Loading from '@components/Loading/Loading';
import Switch from '@material-ui/core/Switch';
import { styles, theme } from './FormaAplicacao.styles';
import FormaAplicacaoAPI from '@resources/FormaAplicacao';
import formatMessage from './i18n/formatMessage';

const iconMenuPontos = require('@images/icone_fab_menu.png');

/**
 * Screen de cadastro de forma de aplicacao
 */
function EditarFormaAplicacao(props) {
  const { classes, match, history, itensState } = props;
  const [itemSelect, setItemSelect] = useState({
    dsFormaAplicacao: ''
  });
  const [stFormaAplicacao, setStFormaAplicacao] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const title = 'formaAplicacao.cadastroDeFormaAplicacao';
    if (itensState.name !== title) {
      props.dispatch({
        type: 'UPDATE_TOOLBAR',
        toolbar: formatMessage(title),
        name: title
      });
    }

    iniciarAtributosEdicao();
  }, []);

  /**
   * Busca os valores iniciais em caso de edição
   */
  function iniciarAtributosEdicao() {
    if (match.params.id !== undefined) {
      setLoading(true);
      FormaAplicacaoAPI.findFormaAplicacaoById(match.params.id)
        .then(query => {
          setStFormaAplicacao(query.data.stFormaAplicacao === 1);
          setItemSelect(query.data);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
          swalError(formatMessage('formaAplicacao.falhaAoCarregarFormaAplicacao'));
        });
    }
  }

  /**
   * Swal de erro
   * @param {*} title
   */
  function swalError(title) {
    swal(title, {
      icon: 'error',
      buttons: {
        confirm: {
          text: 'Ok',
          value: true,
          visible: true,
          closeModal: true,
          className: 'swal2-error'
        }
      }
    });
  }

  function clickCadastrarEditar(values) {
    swal(
      <div>
        <MuiThemeProvider theme={theme}>
          <CircularProgress />
        </MuiThemeProvider>
      </div>,
      {
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
        title: formatMessage(
          match.params.id === undefined ? 'formaAplicacao.salvando' : 'formaAplicacao.atualizando'
        )
      }
    );

    const data = {
      dsFormaAplicacao: values.dsFormaAplicacao,
      stFormaAplicacao: stFormaAplicacao ? 1 : 0
    };

    let editOrUpdate = null;
    let titleSucess = '';
    let titleError = '';

    if (match.params.id === undefined) {
      editOrUpdate = FormaAplicacaoAPI.addFormaAplicacao(data);
      titleSucess = 'formaAplicacaoCadastradoComSucesso';
      titleError = 'falhaAoCadastrarFormaAplicacao';
    } else {
      data.idFormaAplicacao = itemSelect.idFormaAplicacao;

      editOrUpdate = FormaAplicacaoAPI.editFormaAplicacao(data);
      titleSucess = 'formaAplicacaoEditadoComSucesso';
      titleError = 'falhaAoEditarFormaAplicacao';
    }

    editOrUpdate
      .then(() => {
        swal(formatMessage(`formaAplicacao.${titleSucess}`), {
          icon: 'success',
          buttons: {
            confirm: {
              text: 'Ok',
              value: true,
              visible: true,
              closeModal: true,
              className: 'swal2-Ok'
            }
          }
        }).then(() => {
          clickCancelar();
        });
      })
      .catch(() => {
        swalError(formatMessage(`formaAplicacao.${titleError}`));
      });
  }

  function clickCancelar() {
    history.push('/app/forma-aplicacao');
  }

  function checkSwitch() {
    setStFormaAplicacao(!stFormaAplicacao);
  }

  return (
    <Formik
      initialValues={{
        dsFormaAplicacao: itemSelect.dsFormaAplicacao,
        stFormaAplicacao: itemSelect.stFormaAplicacao
      }}
      onSubmit={clickCadastrarEditar}
      validateOnBlur
      enableReinitialize={true}
      validateOnChange={false}
      validationSchema={Yup.object().shape({
        dsFormaAplicacao: Yup.string().required(formatMessage('formaAplicacao.campoObrigatorio'))
      })}
      render={({ values, handleSubmit, errors, touched, handleBlur, handleChange }) => (
        <MuiThemeProvider theme={theme}>
          <div style={{ width: '100%' }}>
            <div className={classes.cardEditar}>
              {loading && <Loading />}
              <CardIcon titulo={formatMessage('formaAplicacao.identificacao')}>
                <Grid container spacing={16} style={{ marginTop: 15 }}>
                  <Grid item xs={6}>
                    <TextField
                      label={formatMessage('formaAplicacao.descricao')}
                      name='dsFormaAplicacao'
                      value={values.dsFormaAplicacao}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.dsFormaAplicacao && touched.dsFormaAplicacao}
                      helperText={
                        errors.dsFormaAplicacao && touched.dsFormaAplicacao
                          ? formatMessage('formaAplicacao.campoObrigatorio')
                          : null
                      }
                      className={classes.font}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <div className={classes.check}>
                      <Switch color='primary' checked={stFormaAplicacao} onChange={checkSwitch} />
                      <label style={{ color: '#000000' }} className={classes.font}>
                        {formatMessage('formaAplicacao.ativo')}
                      </label>
                    </div>
                  </Grid>
                </Grid>
              </CardIcon>
            </div>
            <div className={classes.fab}>
              <ButtonFABMenu
                icon={iconMenuPontos}
                actions={[
                  {
                    icon: <Check style={{ color: 'white' }} />,
                    name: formatMessage('formaAplicacao.salvar'),
                    onClickIcon: handleSubmit,
                    color: '#42ADE8'
                  },
                  {
                    icon: <Close style={{ color: 'white' }} />,
                    name: formatMessage('formaAplicacao.cancelar'),
                    onClickIcon: clickCancelar,
                    color: '#F33A30'
                  }
                ]}
              />
            </div>
          </div>
        </MuiThemeProvider>
      )}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info
});

let enhaced = withStyles(styles)(EditarFormaAplicacao);
export default withRouter(connect(mapStateToProps)(enhaced));
